import {
  Code,
  Details,
  DetailsLink,
  DetailsWrapper,
  ImageWrapper,
  Message,
  Wrapper,
} from "@/components/Error/style";
import { getZendeskSupportUrl } from "@/modules/support/utils";
import { Button } from "@getgrover/ui";
import { useLocale, useTranslations } from "next-intl";

interface ErrorProps {
  code?: string;
  message?: string;
  details?: string | React.ReactNode;
  buttonText?: string;
  contactSupport?: boolean;
  handleButtonClick?: () => void;
  codePosition?: "top" | "bottom";
  illustration?: React.ReactNode;
  buttonLink?: string;
}

export const ErrorFeedback = ({
  code,
  message,
  details,
  buttonText,
  contactSupport = true,
  handleButtonClick,
  codePosition = "bottom",
  illustration,
  buttonLink,
}: ErrorProps) => {
  const t = useTranslations();
  const locale = useLocale();
  const ZendeskSupport = getZendeskSupportUrl(locale);

  return (
    <Wrapper>
      {illustration && <ImageWrapper>{illustration}</ImageWrapper>}
      {code && codePosition === "top" && <Code $top>{code}</Code>}
      <Message>{message || t("error.generic.title")}</Message>
      <DetailsWrapper>
        <Details>{details || t("error.generic.details")}</Details>
        {contactSupport && (
          <Details>
            {t.rich("error.generic.contact_support", {
              support_link: (chunks) => (
                <DetailsLink href={ZendeskSupport} target="_blank">
                  {chunks}
                </DetailsLink>
              ),
            })}
          </Details>
        )}
      </DetailsWrapper>
      {buttonText && buttonLink ? (
        <Button variant="Primary" href={buttonLink} size="L">
          {buttonText}
        </Button>
      ) : (
        buttonText &&
        handleButtonClick && (
          <Button variant="Primary" size="L" onClick={handleButtonClick}>
            {buttonText}
          </Button>
        )
      )}
      {code && codePosition === "bottom" && <Code>{code}</Code>}
    </Wrapper>
  );
};
